const buyUrlPrefix = '/buy'

export const getLegacyBpStaticPath = (asset: string) => {
  return `${buyUrlPrefix}/${asset}`
}

export default buyUrlPrefix
